import { Link } from 'react-router-dom';
import ResponsiveContainer from '../../common/ResponsiveContainer';
import './Home.css';
const ImageFrame = ({ src, alt, className = '' }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={'aspect-square col-span-1 object-cover rounded-xl shadow border-2 border-red-100 border-opacity-5 ' + className}
    />
  );
};

const Home = () => {
  return (
    <>
      <div className='bg-red-100 py-28 pb-48'>
        <ResponsiveContainer className='flex flex-col items-center justify-center h-56 antialiased relative z-10'>
          <h1 className='flex flex-col justify-center text-5xl font-extrabold text-red-1'>
            <span className='big-title text-[2.5rem] md:text-5xl  text-center relative right-5'>
              <span className='text-darkred'>Cientos</span> de series
            </span>
            <span className='big-title text-[2.5rem] md:text-5xl text-center relative left-5'>
              <span className='text-darkred'>Miles</span> de capítulos
            </span>
          </h1>
          <p className='small-title max-w-xl mt-7 text-center text-red-1'>
            Se parte de esta gran comunidad y obtén acceso a más de 5000 capítulos y más de 200 series.
          </p>
          <div className='flex gap-5 mt-10'>
            <Link
              to='/crear-cuenta'
              className='bg-red-1 border-2 border-red-1 text-white rounded font-semibold text-xl px-3 py-1 hover:bg-white hover:text-red-1 transition-all'
            >
              Como me uno
            </Link>
            <Link
              to='/login'
              className='hover:bg-red-1 border-2 border-red-1 hover:text-white rounded font-semibold text-xl px-3 py-1 bg-white text-red-1 transition-all'
            >
              Ya tengo cuenta
            </Link>
          </div>
        </ResponsiveContainer>
      </div>

      <div className='min-w-full overflow-hidden'>
        <svg
          width='100%'
          height='100%'
          id='svg'
          viewBox='0 0 1440 390'
          xmlns='http://www.w3.org/2000/svg'
          className='absolute -top-[6rem] hidden md:block z-0 min-w-[1500px]'
        >
          <path
            d='M 0,400 C 0,400 0,200 0,200 C 77.23846153846151,185.83076923076922 154.47692307692301,171.66153846153844 243,178 C 331.523076923077,184.33846153846156 431.3307692307693,211.1846153846154 506,209 C 580.6692307692307,206.8153846153846 630.1999999999999,175.60000000000002 714,181 C 797.8000000000001,186.39999999999998 915.8692307692309,228.41538461538462 999,224 C 1082.1307692307691,219.58461538461538 1130.3230769230768,168.73846153846154 1198,157 C 1265.6769230769232,145.26153846153846 1352.8384615384616,172.63076923076923 1440,200 C 1440,200 1440,400 1440,400 Z'
            stroke='none'
            strokeWidth='0'
            fill='#FAF9F6'
            fillOpacity='1'
            // className=' h-24'
          />
        </svg>
      </div>
      <div className='relative z-10 pt-4 pb-24 '>
        <ResponsiveContainer className='flex flex-wrap justify-center items-center gap-10 font-roboto-slab text-3xl '>
          <div className='flex flex-col justify-center items-center w-full md:w-[40%] text-center mt-4 '>
            <img src='/fort.png' alt='' width='85px' />
            <span className='font-semibold text-red-1 mt-2'>Funcionando desde 2018</span>
          </div>
          <div className='flex  flex-col justify-center items-center w-full md:w-[40%] text-center mt-4 '>
            <img src='/community.png' alt='' width='85px' />
            <span className='font-semibold text-red-1 mt-2'>Comunidad exclusiva</span>
            <p />
          </div>
          <div className='flex  flex-col justify-center items-center w-full md:w-[40%] text-center md:pt-14 '>
            <img src='/support.png' alt='' width='85px' />
            <span className='font-semibold text-red-1 mt-2'>Soporte personalizado</span>
          </div>
        </ResponsiveContainer>
      </div>
      <div className='diagonal-box'>
        <div className='diagonal-content'>
          <ResponsiveContainer className='relative z-10 flex justify-center text-red-1 mb-10'>
            <span className='font-roboto-slab font-extrabold text-4xl text-center'>Un enorme catálogo que no para de crecer</span>
          </ResponsiveContainer>
          <ResponsiveContainer className='grid lg:grid-cols-7 md:grid-cols-5 grid-cols-3 justify-center flex-wrap gap-4 pt-10 mb-10 px-3'>
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/1.png' className='object-center hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/2.png' className='object-top hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/3.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/4.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/5.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/6.png' className='object-top hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/7.png' className='object-top hidden lg:block' />

            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/8.png' className='object-top hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/9.png' className='object-center hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/10.png' className='object-bottom' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/11.png' className='object-center' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/12.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/13.png' className='object-top hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/14.png' className='object-center hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/15.png' className='object-center hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/16.png' className='object-top hidden md:block' />
            <div className='flex justify-center items-center col-span-3'>
              <span className='font-roboto-slab font-extrabold text-4xl text-center text-off-white'>
                Más de <span className='animate-rotating-bg px-1 '>9000</span> horas de contenido
              </span>
            </div>
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/17.png' className='object-center hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/18.png' className='object-top hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/19.png' className='object-top hidden lg:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/20.png' className='object-center hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/21.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/22.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/23.png' className='object-top' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/24.png' className='object-top hidden md:block' />
            <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/25.png' className='object-center hidden lg:block' />
          </ResponsiveContainer>
        </div>
      </div>
      <ResponsiveContainer className='grid lg:grid-cols-7 md:grid-cols-5 grid-cols-3 gap-4 relative z-20 top-14 mb-10 px-3'>
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/26.png' className='object-center hidden lg:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/27.png' className='object-top hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/28.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/29.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/30.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/31.png' className='object-top hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/32.png' className='object-bottom hidden lg:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/33.png' className='object-bottom hidden lg:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/34.png' className='object-top hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/35.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/36.png' className='object-bottom' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/37.png' className='object-top' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/38.png' className='object-top hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/39.png' className='object-center hidden lg:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/40.png' className='object-center hidden lg:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/41.png' className='object-center hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/42.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/43.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/44.png' className='object-center' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/45.png' className='object-center hidden md:block' />
        <ImageFrame src='https://turkish4love-web.b-cdn.net/collage/46.png' className='object-center hidden lg:block' />
        <div className='w-full flex justify-center items-center mt-2 mb-24 col-span-full'>
          <span className='font-roboto-slab font-extrabold text-4xl text-center  text-red-1'>
            Éstas y <span className='animate-rotating-bg-2 px-1 text-white'>muchas</span> otras series más te están esperando.
          </span>
        </div>
      </ResponsiveContainer>
    </>
  );
};

export default Home;
